/**
 * PodaciKompanije
 * Prima prop `kompanija` = selectedMainEntity iz konteksta
 * Prikazuje: naziv firme, adresu, PIB i matični broj
 */

const styles = {
  wrapper: {
    border: "1px solid #ccc",
    borderRadius: "4px",
    padding: "10px 14px",
    backgroundColor: "#fff",
    fontSize: "13px",
    lineHeight: "1.7"
  },
  row: {
    display: "flex",
    gap: "6px"
  },
  label: {
    fontWeight: "bold",
    minWidth: "120px",
    color: "#555"
  },
  value: {
    color: "#222"
  },
  title: {
    fontWeight: "bold",
    fontSize: "12px",
    textTransform: "uppercase",
    marginBottom: "6px",
    color: "#777"
  }
};

function PodaciKompanije({ kompanija }) {
  if (!kompanija) {
    return (
      <div style={styles.wrapper}>
        <div style={{ color: "#aaa", fontSize: "13px" }}>
          Учитавање података о фирми...
        </div>
      </div>
    );
  }

  const polja = [
    { label: "Назив:", value: kompanija.company_name || kompanija.company_name || "-" },
    { label: "Адреса:", value: kompanija.company_address || kompanija.company_address || "-" },
    { label: "ПИБ:", value: kompanija.pib || "-" },
  ];

  return (
    <div style={styles.wrapper}>
      <div style={styles.title}>Подаци о фирми</div>
      {polja.map(({ label, value }) => (
        <div key={label} style={styles.row}>
          <span style={styles.label}>{label}</span>
          <span style={styles.value}>{value}</span>
        </div>
      ))}
    </div>
  );
}

export default PodaciKompanije;